import React, { useEffect, useState } from 'react';
import { api } from '../api.js';
import { Download } from 'lucide-react';
import { useT } from '../i18n/useT.js';

export default function ReportsPage() {
  const t = useT();
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getReports().then((res) => { setReports(res.items || []); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  const handleDownload = async (id, contentType) => {
    const res = await api.downloadReport(id);
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `report-${id}.${contentType.includes('pdf') ? 'pdf' : contentType.includes('png') ? 'png' : 'html'}`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <>
      <div className="toolbar"><h2>{t('reports.title', 'Reports')}</h2></div>
      <div className="page-content">
        {loading ? <p>{t('reports.loading', 'Loading...')}</p> : reports.length === 0 ? (
          <div className="empty-state"><p>{t('reports.empty', 'No reports generated yet')}</p></div>
        ) : (
          <table className="table">
            <thead><tr><th>{t('reports.table.id', 'ID')}</th><th>{t('reports.table.contentType', 'Content Type')}</th><th>{t('reports.table.created', 'Created')}</th><th>{t('reports.table.expires', 'Expires')}</th><th></th></tr></thead>
            <tbody>
              {reports.map((r) => (
                <tr key={r.id}>
                  <td style={{ fontFamily: 'var(--font-mono)', fontSize: 12 }}>{r.id.slice(0, 16)}...</td>
                  <td>{r.content_type}</td>
                  <td>{new Date(r.created_at).toLocaleString()}</td>
                  <td>{r.expires_at ? new Date(r.expires_at).toLocaleString() : '-'}</td>
                  <td>
                    <button className="btn-secondary" onClick={() => handleDownload(r.id, r.content_type)}>
                      <Download size={14} /> {t('reports.download', 'Download')}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}
